if (!customElements.get('video-source')) {
  class VideoSource extends HTMLElement {
    connectedCallback () {
      const desktopPoster = this.dataset.posterDesktop;
      const mobilePoster = this.dataset.posterMobile;
      const video = this.querySelector('video');

      if (!video || !desktopPoster || !mobilePoster) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      video.setAttribute('poster', isMobile ? mobilePoster : desktopPoster);
    }
  }
  customElements.define('video-source', VideoSource);
}